import { render, staticRenderFns } from "./InhouseWaitingListApproval.vue?vue&type=template&id=48713f6c"
import script from "./InhouseWaitingListApproval.vue?vue&type=script&lang=js"
export * from "./InhouseWaitingListApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports